import {ProductType} from "../../config/constants"
import env from "../../config/env"
import constructProductSummaryOverrideURL from "../constructProductSummaryOverrideURL"

const {REACT_APP_PROD_SUMM_BASEURL, REACT_APP_SERVE_PATH_PREFIX} = env

export const productSummaryEsiBaseUrl = (SITEURL: string, useDevEsi: boolean) =>
    REACT_APP_PROD_SUMM_BASEURL && useDevEsi ? REACT_APP_PROD_SUMM_BASEURL + REACT_APP_SERVE_PATH_PREFIX : SITEURL

export const productSummaryJsonEsiBaseUrl = (SITEURL: string, useDevEsi: boolean) =>
    useDevEsi ? REACT_APP_SERVE_PATH_PREFIX : SITEURL

export function createProductSummaryJsonEsiTag(
    siteUrl: string,
    useDevEsi: boolean,
    apiProxyVersion: string,
    itemNumber: string,
    type: string | undefined = ProductType,
) {
    return `<esi:include src="${productSummaryJsonEsiBaseUrl(
        siteUrl,
        useDevEsi,
    )}/plp-ui/api/${apiProxyVersion}/product-summary/${type}/${itemNumber}" onerror="continue" dca="none" />`
}

export default function createProductSummaryEsiTag(
    itemNumber: string,
    newIn: boolean,
    siteUrl: string,
    useDevEsi: boolean,
    type: string | undefined,
    saleOrClearance: "sale" | "clearance" | "",
    title?: string,
    productSummaryTemplateName?: string | undefined,
    imageRatio?: string | undefined,
    im?: string,
) {
    const fwdSlashType = `/${type || ""}`

    return `<esi:include src="${constructProductSummaryOverrideURL(
        `${productSummaryEsiBaseUrl(siteUrl, useDevEsi)}/product-summary${
            type ? fwdSlashType : ""
        }/${itemNumber}?show-new-in=${newIn}${im ? `&im=${im}` : ``}${
            saleOrClearance ? `&type=${saleOrClearance}` : ``
        }${title ? `&title=${encodeURIComponent(title)}` : ``}`, // Add title as a query parameter
        {
            productSummaryTemplateName,
            imageRatio,
        },
    )}" onerror="continue" dca="none" />`
}
